import type { Plan } from '../types';

/**
 * Le serveur (table `subscriptions`, alimentée par le webhook RevenueCat) est l'autorité du plan :
 * c'est lui qui décide du gating. Un achat réussi côté SDK n'ouvre un droit qu'une fois le webhook
 * passé, ce qui prend de quelques secondes à davantage. Annoncer « activé » avant ce moment promet
 * un plan que le serveur refusera encore à l'appel suivant.
 */
const RANG: Record<Plan, number> = { free: 0, plus: 1, pro: 2, school: 3 };

export function planAtteint(serveur: Plan, attendu: Plan): boolean {
  return RANG[serveur] >= RANG[attendu];
}

export interface ReglagesConfirmation {
  tentatives: number;
  delaiMs: number;
  attendre?: (ms: number) => Promise<void>;
}

// Borné : ~8 s au total. Au-delà, le webhook est vraiment en retard et l'écran passe au message
// neutre plutôt que de faire patienter derrière un indicateur sans fin.
export const CONFIRMATION_PAR_DEFAUT: ReglagesConfirmation = { tentatives: 5, delaiMs: 2000 };

const pause = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

/** `true` dès que le serveur reconnaît au moins `attendu` ; `false` si le budget de lectures est épuisé. */
export async function confirmerPlan(
  lire: () => Promise<Plan>,
  attendu: Plan,
  reglages: ReglagesConfirmation = CONFIRMATION_PAR_DEFAUT,
): Promise<boolean> {
  const attendre = reglages.attendre ?? pause;
  for (let essai = 1; essai <= reglages.tentatives; essai += 1) {
    try {
      if (planAtteint(await lire(), attendu)) return true;
    } catch {
      // une lecture ratée vaut « pas encore » : la suivante peut aboutir
    }
    if (essai < reglages.tentatives) await attendre(reglages.delaiMs);
  }
  return false;
}
